import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/socialSummary',
    name: 'socialSummary',
    component: () => import('@/views/SocialSummary.vue')
  },
  {
    path: '/careerInformation',
    name: 'careerInformation',
    component: () => import('@/views/CareerInformation.vue')
  },
  {
    path: '/gatherInfo',
    name: 'gatherInfo',
    component: () => import('@/views/GatherInfo.vue')
  },
  {
    path: '/access',
    name: 'access',
    component: () => import('@/views/Access.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/views/Policy.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
